export default function TestScroll() {
  return (
    <div
      style={{
        width: "400px",
        height: "200px",
        overflow: "scroll",
        border: "5px solid red"
      }}
    >
      <div style={{ width: "2000px", height: "1000px" }} />
    </div>
  );
}